<template>
  <form v-if="product">
    <h3 class="mb-2" v-if="product._id">
      Edit catalog "{{ product.slotGeneral.name }}"
      <span class="badge badge-warning" title="Status of catalog">Draft</span>
    </h3>
    <h3 class="mb-2" v-if="!product._id">Add Catalog</h3>
    <div class="alert alert-danger" role="alert" v-show="message">
      {{ message }}
    </div>
    <wizard ref="wizard" :steps="steps" :onNext="nextWizard" :onBack="backWizard" :onSubmit="submitApp">
      <!-- General page -->
      <div slot="slotGeneral">
        <div class="row m-0 p-0 b-1">
          <div class="col-lg-12 p-20">
            <!-- Application name -->
            <div class="form-group row m-b-15">
              <label for="name-input" class="col-lg-3 col-form-label">Catalog name<i style="color:#ed6666;">*</i></label>
              <div class="col-lg-7">
                <input class="form-control" type="text" v-model="product.slotGeneral.name" id="name-input"
                  @input="$v.product.slotGeneral.name.$touch()">
                <div v-if="$v.product.slotGeneral.name.$error"
                  :class="{ 'invalid-feedback': $v.product.slotGeneral.name.$error }">This field is required. Please be
                  sure to check.</div>
                <small class="form-text text-muted">What is the name of your data catalog? (required, 2-22 characters)</small>
              </div>
            </div>
            <!-- Application file -->
            <div class="form-group row m-b-15">
              <label for="name-input" class="col-lg-3 col-form-label">Catalog file <i style="color:#ed6666;">*</i></label>
              <div class="col-lg-7">
                <app-file-input class="app-file" :id="'file-input-app'" :type="'file'" :width="'150px'" :height="'70px'"
                  v-model="product.slotGeneral.app"></app-file-input>
                <div v-if="$v.product.slotGeneral.app.$error"
                  :class="{ 'invalid-feedback': $v.product.slotGeneral.app.$error }">This field is required (.zip file).
                  Please be sure to check.</div>
                <small class="form-text text-muted">Upload an exemple of your catalog (.zip required)</small>
              </div>
            </div>
            <!-- Application version -->
            <div class="form-group row m-b-15">
              <label for="version-input" class="col-lg-3 col-form-label">Catalog version <i style="color:#ed6666;">*</i></label>
              <div class="col-lg-7">
                <input class="form-control" type="text" v-model="product.slotGeneral.technicalDetails.version"
                  id="version-input" @input="$v.product.slotGeneral.technicalDetails.version.$touch()">
                <div v-if="$v.product.slotGeneral.technicalDetails.version.$error"
                  :class="{ 'invalid-feedback': $v.product.slotGeneral.technicalDetails.version.$error }">This field is
                  required. Please be sure to check.</div>
                <small class="form-text text-muted">Add the last version (required)</small>
              </div>
            </div>
            
            <!--multi centric-->
            <div class="form-group row m-b-15">
              <label for="multi-centric-input" class="col-lg-3 col-form-label">Multi Centric ?</label>
              <div class="col-lg-7">
                <div class="radio radio-css radio-success pe-2">
                  <input id="radio_y-centric" class="form-check-input" type="radio" name="multiCentric" value="yes"
                    v-model="product.slotGeneral.multiCentric">
                  <label for="radio_y-centric">Yes</label>
                </div>
                <div class="radio radio-css radio-success">
                  <input id="radio_n-centric" class="form-check-input" type="radio" name="multiCentric" value="no"
                    v-model="product.slotGeneral.multiCentric">
                  <label for="radio_n-centric">No</label>
                </div>
              </div>
            </div>
            
            <!--Annotated-->
            <div class="form-group row m-b-15">
              <label for="follow-up-input" class="col-lg-3 col-form-label">Annotated ?</label>
              <div class="col-lg-7">
                <div class="radio radio-css radio-success pe-2">
                  <input id="radio_y-annotated" class="form-check-input" type="radio" name="annotated" value="yes"
                    v-model="product.slotGeneral.annotated">
                  <label for="radio_y-annotated">Yes</label>
                </div>
                <div class="radio radio-css radio-success">
                  <input id="radio_n-annotated" class="form-check-input" type="radio" name="annotated" value="no"
                    v-model="product.slotGeneral.annotated">
                  <label for="radio_n-annotated">No</label>
                </div>
              </div>
            </div>
            
            <!--follow Up-->
            <div class="form-group row m-b-15">
              <label for="follow-up-input" class="col-lg-3 col-form-label">Follow Up ?</label>
              <div class="col-lg-7">
                <div class="radio radio-css radio-success pe-2">
                  <input id="radio_y-follow" class="form-check-input" type="radio" name="followUp" value="yes"
                    v-model="product.slotGeneral.followUp">
                  <label for="radio_y-follow">Yes</label>
                </div>
                <div class="radio radio-css radio-success">
                  <input id="radio_n-follow" class="form-check-input" type="radio" name="followUp" value="no"
                    v-model="product.slotGeneral.followUp">
                  <label for="radio_n-follow">No</label>
                </div>
              </div>
            </div>

             <!--Outcomes-->
             <div class="form-group row m-b-15">
              <label for="outcomes-input" class="col-lg-3 col-form-label">Outcomes</label>
              <div class="col-lg-7">
                <div class="radio radio-css radio-success pe-2">
                  <input id="radio_y-outcomes" class="form-check-input" type="radio" name="outcomes" value="yes"
                    v-model="product.slotGeneral.outcomes">
                  <label for="radio_y-outcomes">Yes</label>
                </div>
                <div class="radio radio-css radio-success">
                  <input id="radio_n-outcomes" class="form-check-input" type="radio" name="outcomes" value="no"
                    v-model="product.slotGeneral.outcomes">
                  <label for="radio_n-outcomes">No</label>
                </div>
              </div>
            </div>
            
            <!--multi device-->
            <div class="form-group row m-b-15">
              <label for="multi-device-input" class="col-lg-3 col-form-label">Multi Device ?</label>
              <div class="col-lg-7">
                <div class="radio radio-css radio-success pe-2">
                  <input id="radio_y-device" class="form-check-input" type="radio" name="multiDevice" value="yes"
                    v-model="product.slotGeneral.multiDevice">
                  <label for="radio_y-device">Yes</label>
                </div>
                <div class="radio radio-css radio-success">
                  <input id="radio_n-device" class="form-check-input" type="radio" name="multiDevice" value="no"
                    v-model="product.slotGeneral.multiDevice">
                  <label for="radio_n-device">No</label>
                </div>
              </div>
            </div>

                        <!-- Device -->
                        <div class="form-group row m-b-15">
              <label class="col-lg-3 col-form-label">Device</label>
              <div class="col-lg-9">
                <div class="row">
                <div class="col-2">
                <div class="form-check mb-1">
                  <input id="GE" class="form-check-input" type="checkbox"
                    v-model="product.slotGeneral.device" value="GE">
                  <label for="GE" class="fs-13px fw-bold">GE</label>
                </div>
              </div>
              <div class="col-2">
                <div class="form-check mb-1">
                  <input id="philips" class="form-check-input" type="checkbox"
                    v-model="product.slotGeneral.device" value="philips">
                  <label for="philips" class="fs-13px fw-bold">Philips</label>
                </div>
              </div>
              <div class="col-3">
                <div class="form-check mb-1">
                  <input id="siemens" class="form-check-input" type="checkbox"
                    v-model="product.slotGeneral.device" value="siemens">
                  <label for="siemens" class="fs-13px fw-bold">Siemens</label>
                </div>
              </div>
              <div class="col-2">
                <div class="form-check mb-1">
                  <input id="canon" class="form-check-input" type="checkbox"
                    v-model="product.slotGeneral.device" value="canon">
                  <label for="canon" class="fs-13px fw-bold">Canon</label>
                </div>
              </div>
            </div>
                <div><small class="form-text text-muted">Select catalog's Device</small></div>
              </div>
            </div>
            
            <!--country-->
            <div class="form-group row m-b-15">
              <label for="country-input" class="col-lg-3 col-form-label">Country</label>
              <div class="col-lg-7 mb-2">
                <div class="input-group">
                  <span class="input-group-text"><i class="fa fa-globe"></i></span>
                  <input 
                    type="text" 
                    v-model="product.slotGeneral.country" 
                    class="form-control form-control-lg" 
                    id="country-input" 
                    placeholder="Country"
                  >
                </div>
              </div>
            </div>
            <!-- Format -->
            <div class="form-group row m-b-15">
              <label class="col-lg-3 col-form-label">Format</label>
              <div class="col-lg-2">
                <div class="form-check mb-1">
                  <input id="dicom" class="form-check-input" type="checkbox"
                    v-model="product.slotGeneral.formats" value="dicom">
                  <label for="dicom" class="fs-13px fw-bold">Dicom</label>
                </div>
                </div>
                <div class="col-2">
                <div class="form-check mb-1">
                  <input id="json" class="form-check-input" type="checkbox"
                    v-model="product.slotGeneral.formats" value="json">
                  <label for="json" class="fs-13px fw-bold">Json</label>
                </div>
                </div>
                <div><small class="form-text text-muted">Select catalog's format</small></div>
              
            </div>
            
           <!-- Studies -->
           <div class="form-group row m-b-15">
              <label for="patient-textarea" class="col-lg-3 col-form-label">Number of studies<i style="color:#ed6666;">*</i></label>
              <div class="col-lg-9">
                <input class="form-control" type="text" v-model="product.slotGeneral.patient" rows="5"
                  id="patient-textarea">
              </input>
               
              </div>
            </div>
            
           <!--age-->
           <div class="form-group row m-b-15">
              <label for="age-textarea" class="col-lg-3 col-form-label">Age<i style="color:#ed6666;">*</i></label>
              <div class="col-lg-9">
                <input class="form-control" type="text" v-model="product.slotGeneral.age" rows="5"
                  id="age-textarea">
              </input>
              </div>
            </div>

             <!--Gender checkbox-->
            <div class="form-group row m-b-15">
              <label for="gender-input" class="col-lg-3 col-form-label">Gender</label>
              <div class="col-lg-7">
                <div class="radio radio-css radio-success pe-2">
                  <input id="radio_m" class="form-check-input" type="radio" name="gender" value="M"
                    v-model="product.slotGeneral.gender">
                  <label for="radio_m">M</label>
                </div>
                <div class="radio radio-css radio-success">
                  <input id="radio_f" class="form-check-input" type="radio" name="gender" value="F"
                    v-model="product.slotGeneral.gender">
                  <label for="radio_f">F</label>
                </div>
                <div class="radio radio-css radio-success">
                  <input id="radio_all" class="form-check-input" type="radio" name="gender" value="All inclusive"
                    v-model="product.slotGeneral.gender">
                  <label for="radio_all">All inclusive</label>
                </div>
              </div>
            </div>

            <!-- Is App already distributed? -->
            <div class="form-group row m-b-15">
              <label for="link-external-distributed-input" class="col-lg-3 col-form-label">Is your catalog already
                distributed online?</label>
              <div class="col-lg-7">
                <div class="radio radio-css radio-success pe-2">
                  <input id="radio_y" class="form-check-input" type="radio" name="externaldistributed" value="yes"
                    v-model="product.slotGeneral.externaldistributed">
                  <label for="radio_y">Yes</label>
                </div>
                <div class="radio radio-css radio-success">
                  <input id="radio_n" class="form-check-input" type="radio" name="externaldistributed" value="no"
                    v-model="product.slotGeneral.externaldistributed">
                  <label for="radio_n">No</label>
                </div>
                <div class="form-input">
                  <input class="form-control" id="is-already-distributed-input" placeholder="" type="url"
                    v-model="product.slotGeneral.externalLinkDist">
                </div>
                <div v-if="$v.product.slotGeneral.externalLinkDist.$error"
                  :class="{ 'invalid-feedback': $v.product.slotGeneral.externalLinkDist.$error }">This field is
                  required.
                  Please be sure to check.</div>
                <small class="form-text text-muted">If yes add internet link here (required)</small>
              </div>
            </div>
            <!-- Application price -->
            <!--div class="form-group row m-b-15">
              <label class="col-lg-3 col-form-label">App price</label>
              <div class="col-lg-7">
                <div class="radio radio-css radio-success">
                  <input class="form-check-input" type="radio" name="appPrice" v-model="product.slotGeneral.price"
                    value="0">
                  <label class="form-check-label">Free App</label>
                </div>
                <div><small class="form-text text-muted">In current version, you can add only Free App</small></div>
              </div>
            </div-->
          </div>
        </div>
      </div>
      <!-- Images page -->
      <div slot="slotImages">
        <div class="row m-0 p-0 b-1">
          <div class="col-12 p-20">
            <!-- Logo -->
            <div class="form-group row m-b-15">
              <label class="col-lg-3 col-form-label">App logo<i style="color:#ed6666;">*</i></label>
              <div class="col-lg-7">
                <div class="logo card text-center">
                  <img :src="imgLogoData.src">
                  <div class="card-footer">
                    <a class="btn btn-link" @click="showToUploadLogo">{{ (imgLogoData.hasImg) ? 'Change Catalog logo' : 'Set Catalog logo' }}</a>
                  </div>
                </div>
                <media-file-input class="app-media" field="app-logo" @crop-success="cropLogoSuccess"
                  @crop-upload-success="cropLogoUploadSuccess" v-model="showLogoInput" :width="575" :height="430"
                  :url="uploadUrl" :no-circle="true" lang-type="en" :headers="headers"
                  img-format="png"></media-file-input>
                <div v-if="$v.product.slotImages.logo.$error"
                  :class="{ 'invalid-feedback': $v.product.slotImages.logo.$error }">This field is required. Please be
                  sure to check.</div>
                <small class="form-text text-muted">Upload the logo of your catalog (required)</small>
              </div>
            </div>
            <!-- Screenshots -->
            <div class="form-group row m-b-15" v-if="product.slotImages.screenshots">
              <label class="col-lg-3 col-form-label">Screenshots ({{ product.slotImages.screenshots.length }})</label>
              <div class="col-lg-9">
                <div class="screenshots-list">
                  <div class="screenshots m-r-5" v-for="(image, imageIndex) in product.slotImages.screenshots"
                    :key="image.slug">
                    <img class="d-block img-thumbnail" :src="image.slug | media({ width: '150' })">
                    <button class="btn btn-link btn-block"
                      @click.prevent.stop="product.slotImages.screenshots.splice(imageIndex, 1)">Remove</button>
                  </div>
                  <div class="card add-screenshot text-muted">
                    <a class="btn" @click="showToUploadScreens">
                      <i class="fa fa-4x fa-plus"></i>
                    </a>
                    <p class="text-muted m-2"> Add screenshot </p>
                  </div>
                  <media-file-input class="app-media" field="app-screenshots"
                    @crop-upload-success="cropScreensUploadSuccess" v-model="showScreensInput" :width="1024"
                    :height="768" :url="uploadUrl" :no-circle="true" lang-type="en"
                    :headers="headers"></media-file-input>
                </div>
                <small class="form-text text-muted">Upload screenshots of your catalog</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Details page -->
      <div slot="slotDetails">
        <div class="row m-0 p-0 b-1">
          <div class="col-md-12 p-20">
            <!-- Overview -->
            <div class="form-group row m-b-15">
              <label for="overview-textarea" class="col-lg-3 col-form-label">Overview<i style="color:#ed6666;">*</i></label>
              <div class="col-lg-9">
                <textarea class="form-control" type="text" v-model="product.slotDetails.overview" rows="5"
                  id="overview-textarea">
                </textarea>
                <div v-if="$v.product.slotDetails.overview.$error"
                  :class="{ 'invalid-feedback': $v.product.slotDetails.overview.$error }">This field is required. Please
                  be sure to check.</div>
                <small id="emailHelp" class="form-text text-muted">Summarize your catalog (required, 20-600
                  characters)</small>
              </div>
            </div>

            <!-- Description -->
            <div class="form-group row m-b-15">
              <label for="description-textarea" class="col-lg-3 col-form-label">Description<i style="color:#ed6666;">*</i></label>
              <div class="col-lg-9">
                <textarea class="form-control" type="text" v-model="product.slotDetails.description" rows="5"
                  id="description-textarea">
                </textarea>
                <div v-if="$v.product.slotDetails.description.$error"
                  :class="{ 'invalid-feedback': $v.product.slotDetails.description.$error }">This field is required. Please
                  be sure to check.</div>
                <small id="emailHelp" class="form-text text-muted">Summarize your catalog (required, 20-600
                  characters)</small>
              </div>
            </div>

            <!-- Categories Title -->
            <div class="form-group row m-b-15">
              <div class="row">
              <label class="col-lg-3 col-form-label">Categories :</label>
            </div>
            <div class="col-lg-3"></div>
            
                <!-- Modality -->
                <div class="col-lg-9">
                  <div class="form-group row mb-1">
                    <div class="col-lg-6">
                      <label class=" col-form-label">Modality</label>
                      <div class="py-2 pt-0 mb-2">
                        <div class="form-check mb-1" v-bind:key="mod" v-for="mod in modalities">
                          <input :id="`mod_${mod}`" class="form-check-input" type="checkbox" :value="mod" v-model="product.slotDetails.categories">
                          <label :for="`mod_${mod}`" class="fs-13px fw-bold text-capitalize">{{ mod }}</label>
                        </div>
                      </div>
                      <label class=" col-form-label">Pathologies</label>
                      <div class="py-2 mb-2 pt-0">
                        <div class="form-check mb-1" v-bind:key="pathology" v-for="pathology in pathologies">
                          <input :id="`pat_${pathology}`" class="form-check-input" type="checkbox" :value="pathology" v-model="product.slotDetails.categories">
                          <label :for="`pat_${pathology}`" class="fs-13px fw-bold text-capitalize">{{ pathology }}</label>
                        </div>
                      </div>
                      <label class=" col-form-label">MRI Protocols</label>
                      <div class="py-2 mb-2 pt-0">
                        <div class="form-check mb-1" v-bind:key="prmri" v-for="prmri in protocolMri">
                          <input :id="`prmri_${prmri}`" class="form-check-input" type="checkbox" :value="prmri" v-model="product.slotDetails.categories">
                          <label :for="`prmri_${prmri}`" class="fs-13px fw-bold text-capitalize">{{ prmri }}</label>
                        </div>
                      </div>
                      <label class="col-form-label">Orientation</label>
                      <div class="py-2 mb-2 pt-0">
                        <div class="form-check mb-1" v-bind:key="orientation" v-for="orientation in orientation">
                          <input :id="`orientation_${orientation}`" class="form-check-input" type="checkbox" :value="orientation" v-model="product.slotDetails.categories">
                          <label :for="`orientation_${orientation}`" class="fs-13px fw-bold text-capitalize">{{ orientation }}</label>
                        </div>
                      </div>
                      <label class="col-form-label">Types</label>
                      <div class="py-2 mb-2 pt-0">
                        <div class="form-check mb-1" v-bind:key="type" v-for="type in types">
                          <input :id="`type_${type}`" class="form-check-input" type="checkbox" :value="type" v-model="product.slotDetails.categories">
                          <label :for="`type_${type}`" class="fs-13px fw-bold">{{ type }}</label>
                        </div>
                      </div>

                    </div>

                  <!-- Organ -->
                    
                    <div class="col-lg-6">
                      <label class=" col-form-label">Organ</label>
                      <div class="py-2 mb-2 pt-0">
                        <div class="form-check mb-1" v-bind:key="organ" v-for="organ in organs">
                          <input :id="`organ_${organ}`" class="form-check-input" type="checkbox" :value="organ" v-model="product.slotDetails.categories">
                          <label :for="`organ_${organ}`" class="fs-13px fw-bold text-capitalize">{{ organ }}</label>
                        </div>
                      </div>
                      <label class=" col-form-label">Body Region</label>
                      <div class="py-2 mb-2 pt-0">
                        <div class="form-check mb-1" v-bind:key="bodyRegion" v-for="bodyRegion in bodyRegions">
                          <input :id="`br_${bodyRegion}`" class="form-check-input" type="checkbox" :value="bodyRegion" v-model="product.slotDetails.categories">
                          <label :for="`br_${bodyRegion}`" class="fs-13px fw-bold text-capitalize">{{ bodyRegion }}</label>
                        </div>
                      </div>
                      <label class="col-form-label">CT Protocols</label>
                      <div class="py-2 mb-2 pt-0">
                        <div class="form-check mb-1" v-bind:key="prct" v-for="prct in protocolCT">
                          <input :id="`prct_${prct}`" class="form-check-input" type="checkbox" :value="prct" v-model="product.slotDetails.categories">
                          <label :for="`prct_${prct}`" class="fs-13px fw-bold text-capitalize">{{ prct }}</label>
                        </div>
                      </div>

                      <label class="col-form-label">Contrast Enhanced</label>
                      <div class="py-2 mb-2 pt-0">
                        <div class="form-check mb-1">
                          <div class="radio radio-css radio-success pe-2">
                        <input id="radio_y-contrast" class="form-check-input" type="radio" name="contrastEnhanced" value="yes"
                          v-model="product.slotDetails.contrastEnhanced">
                        <label for="radio_y-contrast">Yes</label>
                      </div> <br>
                      <div class="radio radio-css radio-success">
                        <input id="radio_n-contrast" class="form-check-input" type="radio" name="contrastEnhanced" value="no"
                          v-model="product.slotDetails.contrastEnhanced">
                        <label for="radio_n-contrast">No</label>
                      </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  </div>
            </div>

            <!-- SYSTEM REQUIREMENT -->
            <div class="form-group row m-b-15">
              <label class="col-lg-3 col-form-label" for="systemrequirement-textarea">Your Business Model ?</label>
              <div class="col-lg-9">
                <vue-editor id="systemRequirement" v-model="product.slotDetails.systemRequirement"
                  :editorToolbar="customToolbar"></vue-editor>
              </div>
            </div>
            <!-- LAST UPDATES -->
            <div class="form-group row m-b-15">
              <label class="col-lg-3 col-form-label" for="lastupdates-textarea">Your business Milestones ?</label>
              <div class="col-lg-9">
                <vue-editor id="lastUpdates" v-model="product.slotDetails.lastUpdates"
                  :editorToolbar="customToolbar"></vue-editor>
                <small class="form-text text-muted">Describe the last updates you do on this catalog</small>
              </div>
            </div>
            <!-- ADD VIDEO -->
            <div class="form-group row m-b-15">
              <label class="col-lg-3 col-form-label" for="video-url-input">Add videos</label>
              <div class="col-lg-9">
                <div class="form-row m-b-5" v-for="(vid, index) in product.slotDetails.videos" :key="vid.src">
                  <div class="col-lg-5 m-r-5 p-0">
                    <input type="text" class="form-control" placeholder="Title" v-model="vid.title">
                  </div>
                  <div class="col-lg-5 m-r-5 p-0">
                    <input type="url" class="form-control" placeholder="Link" v-model="vid.src">
                  </div>
                  <div class="col">
                    <button class="btn btn-danger" @click.prevent.stop="product.slotDetails.videos.splice(index, 1)">
                      <i class="fa fa-minus text-white" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-lg-5 m-r-5 p-3px">
                    <input type="text" class="form-control" placeholder="Title" v-model="video.title">
                  </div>
                  <div class="col-lg-5 m-r-5 p-3px">
                    <input type="url" class="form-control" placeholder="Link" v-model="video.src">
                  </div>
                  <div class="col">
                    <button class="btn btn-primary get-started rounded-pill" @click.prevent.stop="addVideo"
                      :disabled="!video.src || !video.title">
                      <i class="fa fa-plus text-white" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
                <small class="form-text text-muted">Give the iframe url of a youtube video</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Publications page -->
      <div slot="slotPublications">
        <!-- Publications -->
        <div class="row m-0 p-0 b-1">
          <div class="col-md-12 p-20">
            <div class="form-group row m-b-15">
              <label class="col-lg-3 col-form-label">Catalog related to the same studies </label>
              <div class="col-lg-9">
                <div class="form-row m-b-5" v-for="(pub, index) in product.slotPublications.publications"
                  :key="pub.link">
                  <div class="col-lg-5 m-r-5 p-0 mb-2">
                    <input type="text" class="form-control" placeholder="Title" v-model="pub.title">
                  </div>
                  <div class="col-lg-5 m-r-5 p-0 mb-2">
                    <input type="url" class="form-control" placeholder="Link" v-model="pub.link">
                  </div>
                  <div class="col mb-2">
                    <button class="btn btn-danger"
                      @click.prevent.stop="product.slotPublications.publications.splice(index, 1)">
                      <i class="fa fa-minus text-white" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-lg-5 m-r-5 p-3px">
                    <input type="text" class="form-control" placeholder="Title" v-model="publication.title">
                  </div>
                  <div class="col-lg-5 m-r-5 p-3px">
                    <input type="url" class="form-control" placeholder="Link" v-model="publication.link">
                  </div>
                  <div class="col">
                    <button class="btn btn-primary get-started rounded-pill" @click.prevent.stop="addPublication"
                      :disabled="!publication.link || !publication.title">
                      <i class="fa fa-plus text-white" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
                <small class="form-text text-muted">Add related catalog</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Finish page -->
      <div slot="slotSubmit">
        <!-- Submit and send App -->
        <div class="row m-0 p-0 b-1">
          <div class="col-md-12 p-20">
            <div class="jumbotron m-b-0 text-center">
              <h2 class="text-inverse">Ready to Submit</h2>
              <p class="m-b-30 f-s-16">Your catalog is ready to be submitted to womia.io. You may change the metadata and
                binary until you click Submit Catalog</p>
              <!--p><a href="" class="btn btn-primary get-started btn-lg">Proceed to App View</a></p-->
            </div>
          </div>
        </div>
      </div>
    </wizard>
    <div class="confirm-app-modal">
      <modal v-if="showModal" @close="showModal = false">
        <h3 slot="header">Confirm</h3>
        <p slot="body">Please note that after submission, you can not modify your catalog until it has been validated by the
          administrator.
          <br>
          <br> Do you confirm the submission?
        </p>
        <div slot="footer">
          <a href="#" class="btn btn-white router-link-active" style="border-radius: 20px;" data-dismiss="modal"
            @click="showModal = false">Cancel</a>
          <a href="#" class="btn btn-primary get-started rounded-pill" style="border-radius: 20px;" data-dismiss="modal"
            @click="submit()">Submit</a>
        </div>
      </modal>
    </div>
    <div class="info-app-modal">
      <modal v-if="showModalInfo" @close="showModalInfo = false">
        <h3 slot="header" class="text-muted"><i class="fa fa-2x fa-info-circle"></i> Information</h3>
        <p slot="body">Currently, we manage free Catalogs only. Please <a href="/beta/contact-us">contact us</a> if you have
          other requirements.</p>
        <div slot="footer">
          <a href="#" class="btn btn-outline-info" data-dismiss="modal" @click="showModalInfo = false">Continue</a>
        </div>
      </modal>
    </div>
  </form>
</template>
<script>
import Vue from 'vue'
import _ from 'lodash'
import { validationMixin } from 'vuelidate'
import UploadFileInput from '@/components/UploadFileInput'
import MediaFileUpload from 'vue-image-crop-upload'
import Wizard from '@/components/Wizard'
import Dialog from '@/components/Dialog'
import { VueEditor } from 'vue2-editor'
import { required, minLength, maxLength, url, requiredIf,  minValue  } from 'vuelidate/lib/validators'
/* eslint-disable */
export default {
  name: 'EditProductDeveloper',
  components: { 'app-file-input': UploadFileInput, 'media-file-input': MediaFileUpload, 'vue-editor': VueEditor, 'wizard': Wizard, 'modal': Dialog },
  data() {
    return {
      message: null,
      showModal: false,
      showModalInfo: false,
      steps: [{
        label: 'General',
        description: '',
        slot: 'slotGeneral'
      },
      {
        label: 'Images',
        description: '',
        slot: 'slotImages'
      },
      {
        label: 'Details',
        description: '',
        slot: 'slotDetails'
      },
      {
        label: 'Publications',
        description: '',
        slot: 'slotPublications'
      },
      {
        label: 'Submit Catalog',
        description: '',
        slot: 'slotSubmit'
      }
      ],
      publication: {},
      video: {},
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ header: [4, 5, 6, false] }],
        [{ align: [] }],
        ['clean']
      ],
      product: {
        slotGeneral: {
          technicalDetails: {},
        },
        slotImages: {
          logo: {}
        },
        slotDetails: {
        },
        slotPublications: {}
      },
      modalities: ["mri", "xray", "ct", "eeg", "ecg"],
      organs: ["lung", "heart", "liver", "arteries", "trachea", "spine", "pancreas", "spleen", "kidneys", "intestines", "bone", "breast", "teeth", "other"],
      bodyRegions: ["chest", "abdominal", "pelvic", "head", "cervical", "whole body", "chest abdominal", "chest abdominal pelvic", "cervical chest abdominal pelvic", "chest abdominal pelvic head"],
      pathologies: ["healthy", "covid", "nodule", "masse", "fibrosis", "emphysma", "pulmonary interstitial disease", "dilated heart", "thormbus", "atheroma", "dissection", "aneurysm", "pulmonary disease", "arterial disease", "heart disease"],
      orientation: ["axial", "coronal", "sagittal", "short-axis", "long-axis-2-cavities", "long-axis-3-cavities", "long-axis-4-cavities", "multiplanar", "multiplanar-radial", "multiplanar-short-axis"],
      types: ["2D", "2D+T", "2D+t", "3D", "3D+T", "3D+t", "none"],
      age: ["20-30", "30-40", "40-50", "50-60", "60-70", "70-80"],
      protocolMri: ["flow-2D", "flow-3D", "cine SSFP", "cardiac-function", "anatomy", "perfusion", "enhancement", "tagging", "angiography", "t1-mapping", "t2-mapping", "t2* mapping", "dixon"],
      protocolCT: ["chest-", "abdominal-", "pelvic-", "cerebral", "cervical-", "whole-body", "chest-abdominal", "chest-abdominal-pelvic", "cervical-chest-abdominal-pelvic", "chest-abdominal-pelvic-cerebral", "abdominal-pelvic", "cervical spine",
           "Aortic-Angiography", "thoracic-angiography", "supra-aortic-trunks-angiography", "lower-extremity-angiography", "cerebral-angiography", "abdominal-angiography", "thoracic-spine", "lumbar-spine", "coronary"],

      showLogoInput: false,
      showScreensInput: false,
      headers: {
        smail: '*_~'
      },
      uploadUrl: `${Vue.http.options.root}/media`,
      imgLogoData: {
        src: '/beta/static/app-logo-default-300x300.png',
        hasImg: false
      },
      countries: [],
    }
  },
  mixins: [validationMixin],
  validations: {
    product: {
      slotGeneral: {
        name: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(22)
        },
        app: {
          required,
          zipFile(appModel) {
            if (appModel && appModel.type === 'application/zip') {
              return true
            }
            return false
          }
        },
        technicalDetails: {
          version: {
            required
          }
        },
        formats: {
        },
        device: {
        },
        
        
        multiCentric: {},
        multiDevice: {},
        followUp: {},
        annotated: {},
        externaldistributed: {},
        patient: {
        },
        age:{
          required,
        },
        
        country: {
        },
        gender:{
        },
        
        externalLinkDist: {
          required: requiredIf(function () {
            if (this.externaldistributed === 'yes') {
              return true
            }
            return false
          })
        }
      },
      slotImages: {
        logo: {
          required
        },
        screenshots: {
        }
      },
      slotDetails: {
        overview: {
          required,
          minLength: minLength(20),
          maxLength: maxLength(600)
        },
        description: {
          required,
          minLength: minLength(20)
        },
        contrastEnhanced: {
        },
      }
    }
  },
  /*computed: {
    protocolGroups() {
      let groups = [];
      for (let i = 0; i < this.protocolCT.length; i += 11) {
        groups.push(this.protocolCT.slice(i, i + 11));
      }
      return groups;
    }
  },*/
  created: function () {
    if (this.$route.params.slug) {
      this.fetchData()
    } else {
      this.showModalInfo = false
      this.product = {
        slotGeneral: {
          formats: [],
          device: [],
          technicalDetails: {
            size: null,
            version: null,
            createdDate: null,
            updatedDate: null
          }
        },
        slotImages: {
          screenshots: []
        },
        slotDetails: {
          categories: [],
          videos: [],
        },
        slotPublications: {
          publications: []
        }
      }
    }
  },
  methods: {
    hideMessages() {
      this.message = null
    },
    showErrorMessage(message) {
      this.message = message
    },
    fetchData() {
      this.$http.get(`product/dev/${this.$route.params.slug}`).then(
        response => {
          this.populateProduct(response.data)
        },
        err => {
          // error callback
          console.log(err)
        }
      )
    },
    populateProduct(product) {
      /* set general params */
      this.product._id = product._id
      this.product.slug = product.slug
      this.product.slugRef = product.slugRef
      this.product.slotGeneral = {
        name: product.name,
        app: product.app,
        technicalDetails: product.technicalDetails || {},
        formats: product.formats,
        device: product.device,
        gender: product.gender,
        viewer: product.viewer,
        externaldistributed: product.externaldistributed,
        outcomes: product.outcomes,
        multiCentric: product.multiCentric,
        multiDevice: product.multiDevice,
        followUp: product.followUp,
        annotated: product.annotated,
        country: product.country,
        age: product.age,
        patient: product.patient,
        data: product.data,
        externalLinkDist: product.externalLinkDist,
      }
      /* set images params */
      this.product.slotImages = {
        logo: product.logo,
        screenshots: product.screenshots
      }
      if (product.logo) this.imgLogoData = { src: this.$options.filters.media(product.logo.slug, { width: '250' }), hasImg: true }
      /* set details params */
      this.product.slotDetails = {
        overview: product.overview,
        categories: product.categories,
        description: product.description,
        contrastEnhanced: product.contrastEnhanced,
        systemRequirement: product.systemRequirement,
        lastUpdates: product.lastUpdates,
        videos: product.videos || [],
        userGuide: product.userGuide
      }
      /* set publications params */
      this.product.slotPublications = {
        publications: product.publications || []
      }
    },
    isModified() {
      let updateProduct = this.prepareProduct(this.product)
      _.map(_.keys(updateProduct), (key) => {
        if (!updateProduct[key]) updateProduct = _.omit(updateProduct, key)
      })
      updateProduct.technicalDetails = _.pick(updateProduct.technicalDetails, 'version')
      return this.$http.get(`product/dev/${this.product.slug}`).then(
        resp => {
          let oldProduct = resp.data
          oldProduct.technicalDetails = _.pick(oldProduct.technicalDetails, 'version')
          oldProduct = _.pick(oldProduct, _.keys(updateProduct))
          return !_.isEqual(oldProduct, updateProduct)
        })
    },
    prepareProduct(product) {
      return {
        _id: product._id,
        slugRef: product.slugRef,
        name: product.slotGeneral.name,
        app: product.slotGeneral.app,
        technicalDetails: {
          size: product.slotGeneral.app.binSize,
          version: product.slotGeneral.technicalDetails.version
        },
        formats: product.slotGeneral.formats,
        device: product.slotGeneral.device,
        externaldistributed: product.slotGeneral.externaldistributed,
        outcomes:product.slotGeneral.outcomes,
        multiCentric: product.slotGeneral.multiCentric,
        multiDevice: product.slotGeneral.multiDevice,
        gender: product.slotGeneral.gender,
        followUp: product.slotGeneral.followUp,
        annotated: product.slotGeneral.annotated,
        country: product.slotGeneral.country,
        age: product.slotGeneral.age,
        patient: product.slotGeneral.patient,
        data: product.slotGeneral.data,
        externalLinkDist: product.slotGeneral.externalLinkDist,
        logo: product.slotImages.logo,
        screenshots: product.slotImages.screenshots,
        overview: product.slotDetails.overview,
        categories: product.slotDetails.categories,
        contrastEnhanced:product.slotDetails.contrastEnhanced,
        description: product.slotDetails.description,
        systemRequirement: product.slotDetails.systemRequirement,
        lastUpdates: product.slotDetails.lastUpdates,
        videos: product.slotDetails.videos,
        publications: product.slotPublications.publications
      }
    },
    action(promise) {
      this.hideMessages()
      promise.then(
        response => {
          const redirectToMyApps = {
            name: 'ListProductDeveloper'
          }
          this.$router.push(redirectToMyApps)
        },
        () => {
          // error callback
          this.showErrorMessage('Sorry but an error occurred when submitting form')
        }
      )
    },
    create() {
      return this.$http.put(`product/dev`, this.prepareProduct(this.product))
    },
    update() {
      let updateProduct = this.prepareProduct(this.product)
      console.log('updateProduct', updateProduct)
      updateProduct.technicalDetails.updatedDate = new Date()
      return this.$http.post(`product/dev/${this.product.slug}`, updateProduct)
    },
    submit() {
      // use popup for confirmation
      let promise
      if (!this.product._id) {
        promise = this.$http.put(`product/dev`, this.prepareProduct(this.product))
      } else {
        promise = this.$http.post(`product/dev/${this.product.slug}`, this.prepareProduct(this.product))
      }

      promise.then(
        response => {
          this.action(
            this.$http.post(`product/dev/${response.body.slug}/submit-my-app`, { '_id': response.body._id })
          )
        },
        () => {
          // error callback
          this.showErrorMessage('Sorry but an error occurred when submitting form')
        }
      )
      // Hide Modal
      this.showModal = false
    },
    addVideo() {
      this.product.slotDetails.videos.push(this.video)
      this.video = {}
    },
    addPublication() {
      this.product.slotPublications.publications.push(this.publication)
      this.publication = {}
    },
    nextWizard(currentPage) {
      this.hideMessages();
      const currentSlot = this.steps[currentPage].slot;

      if (!this.$v.product[currentSlot] || !this.$v.product[currentSlot].$invalid) {
        if (this.product._id) {
          this.update().then(resp => {
            this.populateProduct(resp.data);
            this.$refs.wizard.goNext(true);
          }, (err) => {
            // Handle error response
            if (err.body.message.indexOf('name.app.already.used') > -1) {
              this.showErrorMessage('Sorry, the same name was already used for another App');
            } else {
              this.showErrorMessage('Sorry but an error occurred when submitting form');
            }
          });
        } else {
          this.create().then(resp => {
            this.populateProduct(resp.data);
            this.$refs.wizard.goNext(true);
          }, (err) => {
            // Handle error response
            if (err.body.message.indexOf('slug_1 dup key') > -1) {
              this.showErrorMessage('Sorry, the same name was already used for another App');
            } else {
              this.showErrorMessage('Sorry but an error occurred when submitting form');
            }
          });
        }
      } else {
        // If there are validation errors in other slots, display a general error message
        this.showErrorMessage('Please make sure all required fields are filled out correctly');
        this.$v.product[currentSlot].$touch();
        return false;
      }
    },
    backWizard(currentPage) {
      this.hideMessages()
      return true
    },
    submitApp(currentPage) {
      this.showModal = true
      return true
    },
    showToUploadLogo() {
      this.showLogoInput = true
    },
    showToUploadScreens() {
      this.showScreensInput = true
    },
    cropLogoSuccess(imgDataUrl, field) {
      this.imgLogoData = { src: imgDataUrl, hasImg: true }
    },
    cropLogoUploadSuccess(jsonData, field) {
      this.product.slotImages.logo = jsonData
    },
    cropScreensUploadSuccess(jsonData, field) {
      this.product.slotImages.screenshots.push(jsonData)
    },
  }
}
</script>
<style lang="scss">
.app-media {
  .app-file .box {
    display: inline-block;
    padding: 4px;
    min-width: 100px;
  }

  .vicp-wrap .vicp-preview {
    height: 250px !important;
  }

  .vicp-wrap .vicp-preview-item {
    padding: 5px;
    width: 200px !important;
    height: 200px !important;
  }

  .vicp-preview-item img {
    width: 200px !important;
    height: auto !important;
  }
}

.card.add-screenshot {
  border: none;

  a {
    width: 110px;
    height: 110px;
    padding: 0.25rem;
    border: 1px dashed;
  }
}

@mixin vertical-align($position: relative) {
  position: $position;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.card.add-screenshot i {
  @include vertical-align();
}
</style>
<style scoped>
.form-check {
  padding-left: 0!important;
  padding-right: 2em;
}
.form-group>label {
  font-size: 14px;
}

.card.logo {
  width: 480px;
  height: auto;
}

.img-thumbnail {
  background: none;
}

.checkbox.checkbox-css,
.radio.radio-css {
  display: inline;
}

.screenshots-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.p-20 {
  padding: 20px !important;
}

@media (min-width: 1200px) {
  .col-lg-12 {
    width: 100%;
  }
}

.m-b-15 {
  margin-bottom: 15px !important;
}


.section-container:before {
  content: "";
  display: table;
  clear: both;
}

.container:before,
.dl-horizontal dd:after,
.dl-horizontal dd:before,
.form-horizontal .form-group:after,
.form-horizontal .form-group:before,
.modal-footer:after,
.modal-footer:before,
.modal-header:after,
.modal-header:before,
.nav:after,
.nav:before,
.navbar-collapse:after,
.navbar-collapse:before,
.navbar-header:after,
.navbar-header:before,
.navbar:after,
.navbar:before,
.pager:after,
.pager:before,
.panel-body:after,
.panel-body:before,
.row:after,
.row:before {
  display: table;
  content: " ";
}

*,
:after,
:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

style attribute {
  user-select: auto;
  cursor: auto;
}

.account-container {
  background: #fff;
  border-radius: 6px;
  position: relative;
}

.account-container .account-body {
  margin-left: 300px;
  padding: 20px 30px;
}

.sw-main .nav-tabs {
  background: #f2f3f4;
  border-radius: 0;
  display: table;
  width: 100%;
}

.sw-main .sw-container {
  position: relative;
  display: block;
  margin: 0;
  padding: 0;
}

.b-1 {
  border: 1px solid #f2f3f4 !important;
}

.p-0 {
  padding: 0 !important;
}

.m-0 {
  margin: 0 !important;
}

.p-3px {
  padding: 3px;
}
.get-started {
  background: #E95913 !important;
}
.get-started:hover {
  background:  #E95913af !important;
}
.form-check .form-check-input{
  margin-left: 0!important;
  margin-right: 0.5em;
  
}
.form-check{
  padding-right: 0!important;
}
.col-form-label{
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/pages/developer/EditProductDeveloper.vue